import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import Pusher from 'pusher-js';

import config from '@/config';

import Home from '../views/Home.vue';

import mdfeRoutes from './mdfe.routes';
import servicosRoutes from './servicos.routes';
import vendasRoutes from './vendas.routes';
import estoqueRoutes from './estoque.routes';
import rmaRoutes from './rma.routes';
import crmRoutes from './crm.routes';
import configuracaoRoutes from './configuracao.routes';
import userRoutes from './user.routes';
import financeiroRoutes from './financeiro.routes';
import pesquisaRoutes from './pesquisa.routes';
import geralRoutes from './geral.routes';
import faturamentoRoutes from './faturamento.routes';
import googleRoutes from './google.routes';
import relatoriosRoutes from './relatorios.routes';
import produtosRoutes from './produtos.routes';
import equipamentosRoutes from './equipamentos.routes';
import loadTourPage from '../services/tour';
import elocaRoutes from './eloca.routes';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  ...mdfeRoutes,
  ...servicosRoutes,
  ...vendasRoutes,
  ...estoqueRoutes,
  ...rmaRoutes,
  ...crmRoutes,
  ...configuracaoRoutes,
  ...userRoutes,
  ...financeiroRoutes,
  ...pesquisaRoutes,
  ...geralRoutes,
  ...faturamentoRoutes,
  ...googleRoutes,
  ...relatoriosRoutes,
  ...produtosRoutes,
  ...equipamentosRoutes,
  ...elocaRoutes,
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const { api_token } = to.query;
  localStorage.clear();
  sessionStorage.clear();
  document.title = `Eloca - ${(to.meta.title ?? to.name)}`;

  if (!to.name || to.name === 'Home') {
    next();
  } else if ((!to.name || to.name !== 'Home') && !api_token) {
    next({
      name: 'Home',
    });
  } else {
    axios.defaults.headers = {
      'Cache-Control': 'no-cache',
    };
    axios.get(`${config.apiUrl}/api/user?api_token=${api_token}`)
      .then((result) => {
        if (result && result.data.api_token === api_token) {
          let ambienteERP = 'app';
          switch (result.data.ambiente) {
            case 'sandbox':
              ambienteERP = 'appbkp';
              break;
            case 'develop':
              ambienteERP = 'develop';
              break;
            case 'local':
              ambienteERP = 'develop';
              break;
            default:
              ambienteERP = 'app';
              break;
          }

          sessionStorage.removeItem('@ERP:empresa');
          sessionStorage.removeItem('@ERP:api_token');
          sessionStorage.setItem('@ERP:ambienteERP', ambienteERP);
          sessionStorage.setItem('@ERP:api_token', api_token);
          sessionStorage.setItem('@ERP:datetime', result.data.datetime);
          sessionStorage.setItem('@ERP:empresa', result.data.empresa);
          sessionStorage.setItem('@ERP:id', result.data.id);
          sessionStorage.setItem('@ERP:sigla', result.data.sigla);
          sessionStorage.setItem('@ERP:programas', JSON.stringify(result.data.programas));
          sessionStorage.setItem('@ERP:tipo', result.data.tipo);
          sessionStorage.setItem('@ERP:host_pusher', result.data.host_pusher);
          sessionStorage.setItem('@ERP:port_pusher', result.data.port_pusher);
          sessionStorage.setItem('@ERP:key_pusher', result.data.key_pusher);
          sessionStorage.setItem('@ERP:cluster_pusher', result.data.cluster_pusher);
          sessionStorage.setItem('@ERP:recnum', result.data.recnum);
          sessionStorage.setItem('@ERP:logname', result.data.logname);
          sessionStorage.setItem('@ERP:user_name', result.data.user_name);
          sessionStorage.setItem('@ERP:logo', result.data.logo);
          sessionStorage.setItem('@ERP:representante', result.data.representante);
          sessionStorage.setItem('@ERP:representantes', JSON.stringify(result.data.representantes));
          sessionStorage.setItem('@ERP:locais', JSON.stringify(result.data.locais));
          sessionStorage.setItem('@ERP:funcionarios', JSON.stringify(result.data.funcionarios));
          sessionStorage.setItem('@ERP:tiposfrete', JSON.stringify(result.data.tiposfrete));
          sessionStorage.setItem('@ERP:percdesclib', JSON.stringify(result.data.percdesclib));
          sessionStorage.setItem('@ERP:usrlocal', JSON.stringify(result.data.usrlocal));

          const keyPusher = result.data.key_pusher;
          const api_key = api_token;
          const clusterPuser = result.data.cluster_pusher;
          const pusherHost = result.data.host_pusher;
          const pusherPort = result.data.port_pusher;
          const recnum = sessionStorage.getItem('@ERP:recnum');

          window.$pusher = new Pusher(`${keyPusher}/${api_key}`, {
            cluster: clusterPuser,
            authEndpoint: `${config.apiUrl}/broadcasting/auth?api_token=${api_key}`,
            authTransport: 'ajax',
            enabledTransports: ['ws', 'wss'],
            wsHost: pusherHost,
            wsPort: pusherPort,
            wssPort: pusherPort,
            wssHost: pusherHost,
            disableStats: true,
            httpHost: `https://${pusherHost}`,
          });
          window.$canalUsuario = window.$pusher.subscribe(`presence-Vue.User.${recnum}`);

          if (to.name) {
            loadTourPage(to.name);
          }

          next();
        } else {
          next({
            name: 'Home',
          });
        }
      })
      .catch((error) => {
        next({
          name: 'Home',
        });
      });
  }
});

export default router;
